// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6789bf19","192":"982294c5","410":"5b826f5b","413":"62bf86d3","453":"da2aa7ab","467":"26e52499","656":"a5975b66","708":"14c2478c","725":"a9844b27","747":"4eed90d3","848":"260b772e","917":"77ee5091","973":"5974db50"}[chunkId] + ".chunk.js";
};